<app-slider [time]=3500 [lista]="listaCarousel" [tipo]="'1'" [numberOfShow]="1" [alto]="altoCarousel" [numberOfSlide]="1" [ancho]="anchoCarousel"></app-slider>

<section class="categorias" *ngIf=" showCategorias ">
	<section>
		<div *ngFor="let newItem of listaCategorias" [ngClass]="{ 'active': newItem.show }" (click)="fnSeleccionCategoria( newItem )">
			<p>{{ newItem.nombre }}</p>
		</div>
	</section>
	<section *ngIf="listaSubcategorias.length > 0">
		<app-slider [lista]="listaSubcategorias" [tipo]="'4'" [numberOfShow]="numberOfShowSubcategorias" [alto]="200" [numberOfSlide]="2" [ancho]="anchoCarousel"></app-slider>
	</section>
</section>
<section class="tienda fondo-blue" [routerLink]="['/tienda']">
	<p class="color-white-bold">Artículos de nuestra tienda</p>
</section>
<br><br>
<app-banner [listaBanner]="banners1"></app-banner>
<br><br>
<div *ngIf="listaMarcas.length > 0">
	<app-slider [time]=8000 [lista]="listaMarcas" [tipo]="'2'" [numberOfShow]="numberOfShowMarcas" [alto]="200" [numberOfSlide]="2" [ancho]="anchoCarousel"></app-slider>
</div>
<!-- <br><br> -->
<!-- <app-banner [listaBanner]="banners2"></app-banner> -->
<br><br>
<section class="tarjetas">
	<div *ngIf="hasSeccionMarca">
		<h1 class="color-purple-bold">{{ seccionMarca.nombre }}</h1>
		<h3 (click)="fnMostrarSeccion( seccionMarca )" class="color-blue-bold">Ver más...</h3>
	</div>
	<app-slider *ngIf="hasSeccionMarca" [time]=0 [lista]="seccionMarca.productos" [tipo]="'3'" [numberOfShow]="numberOfShowMarcas" [alto]="425" [numberOfSlide]="2" [ancho]="anchoCarouselTarjetas"></app-slider>
	
</section>
<br><br>
<app-banner [listaBanner]="banners2"></app-banner>
<br><br>
<section class="tarjetas" *ngFor="let newSeccion of seccionOtras">
	<div>
		<h1 class="color-purple-bold">{{ newSeccion.nombre }}</h1>
		<h3 (click)="fnMostrarSeccion( newSeccion )" class="color-blue-bold">Ver más...</h3>
	</div>
	<app-slider [time]=0 [lista]="newSeccion.productos" [tipo]="'3'" [numberOfShow]="numberOfShowMarcas" [alto]="425" [numberOfSlide]="2" [ancho]="anchoCarouselTarjetas"></app-slider>
</section>